import { useEffect, useState } from 'react'

function getIsDesktop() {
  if (typeof window === 'undefined') return false
  return window.innerWidth >= 1200 && window.innerHeight >= 700
}

export const useScreenSize = () => {
  const [isDesktop, setIsDesktop] = useState(getIsDesktop)
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(getIsDesktop())
      setIsLoaded(true)
    }

    checkScreenSize()

    window.addEventListener('resize', checkScreenSize)

    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  return { isDesktop, isLoaded }
}
